import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#555",
      "fill-rule": "nonzero",
      d: "M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0m0 12.813A5.813 5.813 0 0 1 7 1.188a5.813 5.813 0 0 1 0 11.625M7 2.21a.737.737 0 1 1 0 1.473.737.737 0 0 1 0-1.473m-1.172 8.65c-.294-1.746.9-4.672.597-5.254-.302-.582-.294-.582-.597-.582 0 0 2.086-1.171 2.086 0s-.892 4.672-.597 5.254.899 0 .899.582-2.085 1.754-2.388 0"
    }, null, -1)
  ])))
}
export default { render: render }